export const CONFIG_API_MOCKED = false //Boolean(process.env.CONFIG_API_MOCKED)
export const COMPANY_API_COUNTRY_MOCKED = false // Boolean(process.env.COMPANY_API_COUNTRY_MOCKED)
export const COMPANY_API_SETTINGS_MOCKED = false //Boolean(process.env.COMPANY_API_SETTINGS_MOCKED)
